const ns = {};

ns.PriorityList = [
    {
        value: 1,
        label: "Critical"
    },
    {
        value: 2,
        label: "High"
    },
    {
        value: 3,
        label: "Medium"
    },
    {
        value: 4,
        label: "Low"
    },
    {
        value: 5,
        label: "Schedule"
    },
];

// TODO - update to use the store ...
ns.JobStatusList = [
{
    value: 1,
    label: "In Progress"
},
{
    value: 2,
    label: "Work Complete"
},
{
    value: 3,
    label: "Invoiced"
},
{
    value: 4,
    label: "PAID"
},
{
    value: 5,
    label: "Billing Hold"
},
{
    value: 6,
    label: "Estimated"
},
{
    value: 7,
    label: "Account Suspended"
},
{
    value: 8,
    label: "In Review"
},
{
    value: 9,
    label: "Stalled"
},
{
    value: 10,
    label: "Awaiting PO"
},
{
    value: 11,
    label: "CST SUPPORT"
},
{
    value: 12,
    label: "MAINTENANCE"
},
{
    value: 13,
    label: "NOT STARTED"
},
{
    value: 14,
    label: "PROJECT"
},
{
    value: 15,
    label: "EST DECLINED"
},
{
    value: 16,
    label: "LOST REVENUE"
},
{
    value: 17,
    label: "RECOUP"
},
{
    value: 18,
    label: "PENDING CUST APPROVAL"
},
{
    value: 19,
    label: "RENEWALS"
},
{
    value: 20,
    label: "CANCELLED/CLOSED"
},
{
    value: 21,
    label: "ADMINISTRATIVE"
},
{
    value: 22,
    label: "IT SUPPORT"
},


];

ns.NoteStatus = [
    {
        label: "Inactive",
        value: 0
    },
    {
        label: "Active",
        value: 1,
    }
];

ns.MileageStatus = [
    {
        label: "Not Started",
        value: 0
    },
    {
        label: "In Progress",
        value: 1
    },
    {
        label: "Billable",
        value: 2
    },
    {
        label: "Not Billable",
        value: 3
    },
    {
        label: "Billed",
        value: 4
    },
    {
        label: "Not Billed",
        value: 5
    },
    {
        label: "Completed",
        value: 6
    },
    {
        label: "Deferred",
        value: 7
    },
    {
        label: "Waiting",
        value: 8
    },
    {
        label: "Project Work",
        value: 9
    },
    {
        label: "Management Review",
        value: 10
    },
    {
        label: "Lost Revenue",
        value: 11
    },
    {
        label: "Comp/Discount",
        value: 12
    },
    {
        label: "New Hire Training",
        value: 13
    },
    {
        label: "Estimate Required",
        value: 14
    },
];

/* static data structures */
ns.BillingIncrements = [
    {
        label: "15 mins",
        value: 15
    },
    {
        label: "30 mins",
        value: 30
    },
    {
        label: "45 mins",
        value: 45
    },
    {
        label: "Hourly",
        value: 60
    }
];

ns.TaskStatus = [
    {
        value: 1,
        label: "Not Started"
    },
    {
        value: 2,
        label: "In Progress"
    },
    {
        value: 3,
        label: "Billable"
    },
    {
        value: 4,
        label: "Not Billable"
    },
    {
        value: 5,
        label: "Billed"
    },
    {
        value: 6,
        label: "Not Billed"
    },
    {
        value: 7,
        label: "Complete"
    },
    {
        value: 9,
        label: "Waiting"
    },
    {
        value: 10,
        label: "Project Work"
    },
    {
        value: 12,
        label: "Lost Revenue"
    },
    {
        value: 13,
        label: "Comp/Discount"
    },
    {
        value: 14,
        label: "New Hire Training"
    },
    {
        value: 15,
        label: "Estimate Required"
    },
];

ns.GetTaskStatus = (id) =>
{
    for (let i = 0; i < ns.TaskStatus.length; i++)
    {
        let row = ns.TaskStatus[i];
        if (row.value === id)
        {
            return row;
        }
    }

    return null;
};

ns.JobStatus = [
    {
        value: 1,
        label: "In Progress"
    },
    {
        value: 2,
        label: "Work Complete"
    },
    {
        value: 3,
        label: "Invoiced"
    },
    {
        value: 4,
        label: "PAID"
    },
    {
        value: 5,
        label: "Billing Hold"
    },
    {
        value: 6,
        label: "Estimated"
    },
    {
        value: 7,
        label: "Account Suspended"
    },
    {
        value: 8,
        label: "In Review"
    },
    {
        value: 9,
        label: "Stalled"
    },
    {
        value: 10,
        label: "Awaiting PO"
    }, 
];

ns.GetJobStatus = (id) =>
{
    id = Number(id);
    for (let i = 0; i < ns.JobStatusList.length; i++)
    {
        let row = ns.JobStatusList[i];
        if (row.value === id)
        {
            return row;
        }
    }

    return null;
};


ns.OrderStatus = [
    {
        value: 1,
        label: "Requested"
    },
    {
        value: 2,
        label: "Approved for order"
    },
    {
        value: 3,
        label: "Ordered"
    },
    {
        value: 4,
        label: "Received"
    },
    {
        value: 5,
        label: "Billed"
    },
    {
        value: 6,
        label: "Cancelled"
    },
    {
        value: 7,
        label: "Returned"
    },
    {
        value: 8,
        label: "Back Ordered"
    },
];

ns.Payments = [
    {
        value: "1",
        label: "Cash"
    },
    {
        value: "2",
        label: "BB&T debit card"
    },
    {
        value: "3",
        label: "Elan credit card"
    },
    {
        value: "4",
        label: "Check"
    },
    {
        value: "5",
        label: "Checking Account"
    },
    {
        value: "6",
        label: "Vendor Credit Line"
    },
    {
        value: "7",
        label: "Part from Inventory"
    },
    {
        value: "8",
        label: "EE Credit Card"
    },
    {
        value: "9",
        label: "JP CC"
    },
    {
        value: "10",
        label: "EV CC"
    },
    {
        value: "11",
        label: "RS CC"
    },
    {
        value: "12",
        label: "DK CC"
    },
    {
        value: "13",
        label: "Petty Cash"
    },
    {
        value: "14",
        label: "CL CC"
    },
    {
        value: "15",
        label: "AV CC"
    },
    {
        value: "16",
        label: "JF CC"
    },
];

ns.Vehicles = [
    {
        value: "Personal Vehicle",
        label: "Personal Vehicle"
    },
    {
        value: "Mazda",
        label: "Mazda"
    },
    {
        value: "GMC Van",
        label: "GMC Van"
    },
    {
        value: "Promaster R1422",
        label: "Promaster R1422"
    },
    {
        value: "Promaster R1423",
        label: "Promaster R1423"
    },
    {
        value: "PMC 1423",
        label: "PMC 1423"
    },
];

ns.ActiveStatus = [
    {
        value: 1,
        label: "Active"
    },
    {
        value: 0,
        label: "Inactive",
    }
];

ns.TimeLocations = [
    {
        value:1, 
        label: "ON-SITE"
    },
    {
        value:2, 
        label: "GTA"
    },
    {
        value:3, 
        label: "WEB"
    },
    {
        value:4, 
        label: "PHONE/EMAIL"
    },
    {
        value:5, label: "IN HOUSE"
    },
    {
        value:6, label: "OVERSIGHT"
    },
];


export default ns;